export function isAdSlotVisible(slotElementId) {
    const element = global.document.querySelector(`#${slotElementId}`);
    if (!element) {
        return false;
    }
    const elPosition = element.getBoundingClientRect();
    return (elPosition.top >= 0 &&
        elPosition.left >= 0 &&
        elPosition.bottom <=
            (global.window.innerHeight ||
                global.document.documentElement.clientHeight) &&
        elPosition.right <=
            (global.window.innerWidth || global.document.documentElement.clientWidth));
}
